import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const ContentOuterContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.neutral99};
    min-height: 100dvh;
  `,
);

export const ContentInnerContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.neutral99};
    min-height: 100dvh;
    max-width: ${theme.sz.s};
    padding: ${theme.sz.s6};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;

    @media (max-width: ${theme.sz.lg}) {
      padding: ${theme.sz.s4};
    }
  `,
);

export const IconBadge = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s20};
    height: ${theme.sz.s20};
    margin-bottom: ${theme.sz.s6};
    border-radius: 50%;
    background: ${theme.co.primary90};
  `,
);

export const BadgeIcon = styled(Icon)(
  ({ theme }) => css`
    width: ${theme.sz.s12};
    height: ${theme.sz.s12};
    color: ${theme.co.primary30};
  `,
);

export const StreakCount = styled.span(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    ${theme.typography.heading.desktop.m};
    color: ${theme.co.neutral99};
    font-weight: 700;
    pointer-events: none;
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};
    color: ${theme.co.secondary0};
    text-align: center;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s4};

    @media (max-width: ${theme.sz.lg}) {
      ${theme.typography.heading.mobile.m};
    }
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary20};
    text-align: center;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s6};
  `,
);

export const CommitmentList = styled.ul(
  ({ theme }) => css`
    list-style: none;
    width: 100%;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s6};
    padding: ${theme.sz.s0};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
  `,
);

export const CommitmentOption = styled.li<{ $active?: boolean }>(
  ({ theme, $active }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.sz.s3};
    width: 100%;
    padding: ${theme.sz.s4};
    border-radius: ${theme.bo.medium};
    border: 1px solid ${$active ? theme.co.secondary0 : theme.co.neutral90};
    background: ${$active ? theme.co.primary90 : theme.co.neutral99};
    color: ${$active ? theme.co.secondary0 : theme.co.neutral50};
    ${theme.typography.paragraph.m};
  `,
);

export const CommitmentCheck = styled(Icon)(
  ({ theme }) => css`
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    flex-shrink: 0;
    color: ${theme.co.secondary0};
  `,
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.sz.s4};
  `,
);

export const FreeLink = styled.button(
  ({ theme }) => css`
    display: block;
    width: 100%;
    text-align: center;
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary50};
    text-decoration: underline;
    font-weight: 500;
    background: none;
    border: none;
    cursor: pointer;
    padding: ${theme.sz.s2} ${theme.sz.s0};
  `,
);
